<template>
<div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-dark">
    </base-header>
    <card>
        <b-container fluid class="mt--6">
            <b-row>
                <b-col>
                    <div class="card-wrapper">
                        <card>
                            <h2 class="mb-0">Pegawai Lantikan Sebelum 2003</h2>
                            <br />
                            <b-row class="my-1">
                                <b-col sm="3">
                                    <label>NAMA</label>
                                </b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="5">{{NamaPeribadi}}</b-col>
                            </b-row>
                            <b-row class="my-1">
                                <b-col sm="3">
                                    <label>NO KAD PENGENALAN </label>
                                </b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="5" class="col text-left">{{NoKP}}</b-col>
                                <!-- <b-button variant="default">Carian Pengguna</b-button> -->
                            </b-row>
                            <!-- <b-row>
                                <b-col sm="7">
                                    <b-form-group label="STATUS MAKLUMAT PEGAWAI LANTIKAN SEBELUM 2003" v-slot="{ ariaDescribedby }">
                                        <b-form-radio-group variant="success" id="btn-radios-1" v-model="StatusLantikanSblm2003" :options="options" :aria-describedby="ariaDescribedby" name="radios-stacked" stacked></b-form-radio-group>
                                    </b-form-group>
                                </b-col>
                            </b-row> -->
                        </card>
                    </div>
                </b-col>
            </b-row>
            <br />
            <div>
                <validation-observer v-slot="{ invalid }">
                    <card header-classes="bg-transparent">
                        <h3 class="mb-0">Hanya Diisi Oleh Pegawai Lantikan Sebelum 2003</h3>
                        <br />
                        <div class="pl-lg-4">
                            <validation-provider name="Gaji pada 31.12.2002" :rules="{ required: true }" v-slot="validationContext">
                                <b-row class="my-1">
                                    <b-col sm="3">Gaji pada 31.12.2002 </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="4">
                                        <b-form-input v-model="ObjLantikanSblm2003.Sal2002" :state="getValidation(validationContext)"></b-form-input>
                                    </b-col>
                                </b-row>
                            </validation-provider>
                            <b-row>
                                <b-col sm="1"></b-col>
                            </b-row>
                            <validation-provider name="Klasifikasi Perkhidmatan" :rules="{ required: true }" v-slot="validationContext">
                                <b-row>
                                    <b-col sm="3"> Klasifikasi Perkhidmatan pada 31.12.2002 </b-col>
                                    <b-col sm="1"> :</b-col>
                                    <b-col sm="8">
                                        <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ObjLantikanSblm2003.ServClassId" :options="ServClassList" @change="runMethod()" style="width: 50%" aria-describedby="input-2-live-feedback">
                                            <template #first>
                                                <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                            </validation-provider>
                            <validation-provider name="Skim Perkhidmatan" :rules="{ required: true }" v-slot="validationContext">
                                <b-row>
                                    <b-col sm="3"> Skim Perkhidmatan pada 31.12.2002</b-col>
                                    <b-col sm="1"> :</b-col>
                                    <b-col sm="8">
                                        <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ObjLantikanSblm2003.SchmOfServId" :options="SchmOfServList" @change="runMethod2()" style="width: 60%" aria-describedby="input-2-live-feedback">
                                            <template #first>
                                                <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                            </validation-provider>
                            <b-row class="my-1">

                            </b-row>
                            <validation-provider name="Gred Jawatan Lantikan Pertama" :rules="{ required: true }" v-slot="validationContext">
                                <b-row class="my-1">
                                    <b-col sm="3"> Gred Jawatan pada 31.12.2002 </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">
                                        <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ObjLantikanSblm2003.SalGrdID" :options="SalGrdList" style="width: 60%" aria-describedby="input-2-live-feedback">
                                            <template #first>
                                                <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                            </validation-provider>
                            <validation-provider name="Tarikh Dijangka Bersara" :rules="{ required: true }" v-slot="validationContext">
                                <b-row class="my-1">
                                    <b-col sm="3"> Tarikh Pergerakan Gaji (TPG) pada 31.12.2002 </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">

                                        <base-input type="date" v-model="ObjLantikanSblm2003.DtTPG2002" size="sm"></base-input>
                                    </b-col>
                                </b-row>
                            </validation-provider>
                            <b-col>&nbsp;</b-col>
                            <b-form-row>
                                <b-col>
                                    <b-form-group>
                                        <div>
                                            <b-col>&nbsp;</b-col>
                                            <b-col align="center">
                                                <b-button variant="success" type="submit" @click="simpan()" v-show="simpa2">SIMPAN</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">KEMBALI</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">SETERUSNYA</b-button>
                                                <!-- <b-button size="md" variant="primary" v-show="active" @click="nextPapar()">PAGE PAPAR</b-button> -->

                                            </b-col>
                                        </div>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>
                        </div>
                    </card>
                </validation-observer>
            </div>
            <!-- <div v-if="StatusLantikanSblm2003 == 0">
                <card header-classes="bg-transparent">
                    <b-button size="md" variant="primary" @click="nextNonData()">SETERUSNYA</b-button>

                    <br />
                </card>
            </div> -->
        </b-container>
    </card>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
export default {
    data() {
        return {
            form: {
                NoKP: null
            },
            options: [{
                    text: 'YA',
                    value: '1'
                },
                {
                    text: 'TIDAK',
                    value: '0'
                }
            ],
            ServClassId: null,
            SchmOfServId: null,
            selectedSalGrd: null,
            ServClassList: [],
            SchmOfServList: [],
            SalGrdList: [],
            StatusLantikanSblm2003: null,
            ObjLantikanSblm2003: {},
            active: false,
            simpa2: true,
        }
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {

            return dirty || validated ? valid : null;
        },
        runMethod() {
            console.log(this.ServClassId);

            let Search = {
                ServClassId: this.ObjLantikanSblm2003.ServClassId,
            };

            GetselenggaraService.getSenaraiSchmOfServ(Search)
                .then((resp) => {
                    this.SchmOfServList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        runMethod2() {
            console.log("this SchmOfServId", this.SchmOfServId);
            let Search2 = {
                ServClassId: this.ObjLantikanSblm2003.ServClassId,
                SchmOfServId: this.ObjLantikanSblm2003.SchmOfServId,
            };
            console.log("this Search2", this.Search2);
            GetselenggaraService.getSenaraiSalGrd(Search2)
                .then((resp) => {
                    this.SalGrdList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        simpan() {

            this.ObjLantikanSblm2003.StatusLantikanSblm2003 = 1;

            this.$store.commit("addMaklPegSeb2003", this.ObjLantikanSblm2003);
            // this.simpa2 = false;
            // this.active = true;
            // console.log(this.ObjLantikanSblm2003);

            this.$router.push({
                name: 'MAKLUMAT KIRA GAJI',
            })

        },

        next() {

            console.log(this.NoKP)
            this.$router.push({
                name: 'STATUS TIADA PERGERAKAN GAJI TAHUNAN',
            })
        },

        nextNonData() {
            this.$store.commit("addMaklPegSeb2003", {});
            console.log(this.NoKP)
            this.$router.push({
                name: 'STATUS TIADA PERGERAKAN GAJI TAHUNAN',
            })
        },
        nextPapar() {
            this.$router.push({
                name: 'MAKLUMAT KIRA GAJI',
            })
        }
    },
    computed: {
        MaklumatPeribadiInStore() {
            return Store.state.MaklumatPeribadi;
        },
        MaklPegSeb2003InStore() {
            return Store.state.MaklPegSeb2003;
        },

    },
    created() {

        GetselenggaraService.getSenaraiServClass()
            .then((resp) => {
                this.ServClassList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        console.log("state", this.$store.state)

        this.NamaPeribadi = this.$store.state.MaklumatPeribadi.Nama;
        this.NoKP = this.$store.state.MaklumatPeribadi.NoKP;

        this.ObjLantikanSblm2003 = this.$store.state.MaklPegSeb2003;

       this.ObjLantikanSblm2003.DtTPG2002 = moment(this.$store.state.MaklPegSeb2003.DtTPG2002, "DD-MM-YYYY").format("YYYY-MM-DD");

        GetselenggaraService.getSenaraiServClass()
            .then((resp) => {
                this.ServClassList = resp.data;
                //console.log("SERVE",this.ServClassList);
            })
            .catch((err) => {
                console.log(err);
            });

        GetselenggaraService.getSenaraiSchmOfServ()
            .then((resp) => {
                this.SchmOfServList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        GetselenggaraService.getSenaraiSalGrd()
            .then((resp) => {
                this.SalGrdList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

    }
}
</script>

<style>
h2 {
    text-decoration: underline;
}

.numbers {
    text-decoration: underline;
    text-decoration-color: white;
}
</style>
